import {FlatTreeControl} from '@angular/cdk/tree';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseComponent, FileService, LazyCatalog} from 'compob2b-libs';
import {take, takeUntil} from 'rxjs/operators';
import {CustomerCatalogService} from '../services/customer-catalog.service';
import {CustomerDynamicDataSource} from './customer-dynamic-data-source';

@Component({
    selector: 'app-modal-catalog',
    templateUrl: './modal-catalog.component.html',
    styleUrl: './modal-catalog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ModalCatalogComponent extends BaseComponent implements OnInit {

  treeControl: FlatTreeControl<LazyCatalog>;
  dataSource: CustomerDynamicDataSource;
  isShowBlock = false;
  catalogId: string;
  limit: string;
  noIconSrc = '/assets/images/s.gif';

  constructor(private readonly catalogService: CustomerCatalogService,
              protected readonly route: ActivatedRoute,
              private readonly fileService: FileService
  ) {
    super();
  }

  ngOnInit() {
    this.treeControl = new FlatTreeControl<LazyCatalog>(this.getLevel, this.isExpandable);

    this.route.queryParamMap
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(param => {
        this.catalogId = param.get('catalog_id');
        this.limit = param.get('limit');
      });

    this.dataSource = new CustomerDynamicDataSource(this.treeControl, this.catalogService, this.unsubscribe);
    this.catalogService.initCatalogTree()
      .pipe(take(1))
      .subscribe(tree => this.dataSource.data = tree);
  }

  getLevel = (node: LazyCatalog) => node.level;

  isExpandable = (node: LazyCatalog) => !node.lastLevel;

  hasChild = (_: number, nodeData: LazyCatalog) => !nodeData.lastLevel;

  navToCatalog() {
    // При нажатии на кнопку "Каталог", учитывать выбранный лимит для пагинации
    this.router.navigate(['catalog'], {
      queryParams: {
        limit: this.limit,
      }
    });
  }

  setId(id: string) {
    this.catalogId = id;
  }

  showBlock(show: boolean) {
    this.isShowBlock = show;
  }

  public getIconUri(icon: string) {
    return icon && icon !== '.' ? this.fileService.getImageSrc(icon) : this.noIconSrc;
  }
}
